/**
 * @file 路由
 * @author  fangsimin
 * @date    2019-01-02 14:04:10
 * @last Modified by    fangsimin
 * @last Modified time  2020-02-09 21:01:46
 */

import Vue from 'vue';
import Router from 'vue-router';
// import App from '@/App';
import CmpMobileApp from '@/modules/mobile/App';
import CmpApp from '@/modules/cmp/App';
import Login from '@/pages/Login';
import constants from '@/constants';
import cmpMobilePathConfig from '@/modules/mobile/constants/pathConfig';
import cmpPathConfig from '@/modules/cmp/constants/pathConfig';

// import {getUserInfo} from './auth';

const PATH = constants.path;
const env = process.env;

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [{
        path: PATH['login'],
        name: 'login',
        component: Login
    }, {
        path: '/cmp',
        name: 'cmp',
        component: CmpApp,
        // 所有路由配置处，做成子路由是因为导航处相同
        children: cmpPathConfig['routes']
    }, {
        path: '/business/mobile',
        name: 'mobile',
        component: CmpMobileApp,
        // 所有路由配置处，做成子路由是因为导航处相同
        children: cmpMobilePathConfig['routes']
    }, {
        path: PATH['create-account'],
        name: 'create-account',
        component: resolve => require(['@/modules/cmp/pages/accountMgr/create'], resolve)
    }, {
        path: PATH['onboarding-result'],
        name: 'onboarding-result',
        component: resolve => require(['@/modules/cmp/pages/accountMgr/applied-list'], resolve)
    }, {
        path: PATH['account'],
        name: 'account',
        component: resolve => require(['@/modules/cmp/pages/accountMgr/audit'], resolve)
    }, {
        path: PATH['onboarding'],
        name: 'onboarding',
        component: resolve => require(['@/modules/cmp/login.vue'], resolve)
    }, {
        path: PATH['user'],
        name: 'user',
        component: resolve => require(['@/modules/cmp/submitUserInfo.vue'], resolve)
    }, {
        path: PATH['home'],
        name: 'home',
        component: resolve => require(['@/modules/cmp/pages/home/index.vue'], resolve)
    }, {
        path: PATH['partner'],
        name: 'partner',
        component: resolve => require(['@/modules/cmp/pages/home/partner/index.vue'], resolve)
    }, {
        path: PATH['partner-detail'],
        name: 'partner-detail',
        component: resolve => require(['@/modules/cmp/pages/home/partner/details.vue'], resolve)
    }, {
        path: PATH['solutions'],
        name: 'solutions',
        component: resolve => require(['@/modules/cmp/pages/home/solutions/index.vue'], resolve)
    }, {
        path: PATH['cases'],
        name: 'cases',
        component: resolve => require(['@/modules/cmp/pages/home/cases/index.vue'], resolve)
    }, {
        path: PATH['case-detail'],
        name: 'case-detail',
        component: resolve => require(['@/modules/cmp/pages/home/cases/detail.vue'], resolve)
    }, {
        path: PATH['about'],
        name: 'about',
        component: resolve => require(['@/modules/cmp/pages/home/about/index.vue'], resolve)
    }, {
        path: PATH.course,
        name: 'course',
        component: resolve => require(['@/modules/cmp/pages/home/course/index.vue'], resolve)
    }, {
        path: PATH['course-details'],
        name: 'course-details',
        component: resolve => require(['@/modules/cmp/pages/home/course/detail.vue'], resolve)
    }, {
        path: PATH['inviteError'],
        name: 'invite-error',
        component: resolve => require(['@/modules/cmp/invite-error.vue'], resolve)
    }, {
        path: '/',
        beforeEnter: async (to, fromPath, next) => {
            try {
                // const userinfo = await getUserInfo();
                next();
            } catch (e) {
                next({
                    path: PATH['home']
                });
            }
        }
    }, {
        path: '**',
        component: resolve => require(['@/pages/404'], resolve)
    }]
});

// Route case-sensitivity hotfix
if (router.mode === 'history') {
    router.history.getCurrentLocation = () => {
        let path = window.location.pathname;
        let base = router.history.base;
        // Removes base from path (case-insensitive)
        if (base && path.toLowerCase().indexOf(base.toLowerCase()) === 0) {
            path = path.slice(base.length);
        }
        return (path.toLowerCase() || '/') + window.location.search + window.location.hash;
    };
}
router.beforeEach(async (to, from, next) => {
    try {
        let curPath = to.path;
        if (curPath.indexOf('mobile') > -1) {
            next();
            return false;
        } else {
            var userAgentInfo = navigator.userAgent;
            var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod', 'iPad'];
            if (Agents.some(item => userAgentInfo.indexOf(item) > -1)) {
                next({path: '/business/mobile/home', replace: true});
            }
        }
        const userData = window.userDataJs;
        const userInfo = userData && userData.user ? userData.user : null;
        // let avaliableURIList = userData && userData.menus ? userData.menus : [];
        // let urlList = avaliableURIList.map(url => url.uri);
        // const redirectUrl = localStorage.getItem('redirectUrl');
        let hasInfo = userInfo && userInfo.hasInfo ? userInfo.hasInfo : false;
        // console.log(curPath, hasInfo, router, PATH['home']);
        let userLoginArr = [PATH['create-account'], PATH['onboarding-result']];
        /* eslint-disable */
        let noNeedLogin = [PATH['home'], PATH['solutions'], PATH['cases'], PATH['case-detail'],
            PATH['about'], PATH['partner'], PATH['FAQ'], PATH['partner'], PATH['partner-detail']];
        // if (curPath === PATH['onboarding'] || curPath === PATH['setInfo']) {
        // next(form.path);
        // }
        // if (!userInfo && userLoginArr.indexOf(curPath) > -1) {
        // // if (!userInfo && curPath !== PATH['onboarding']) {
        //     curPath !== PATH['setInfo'] && localStorage.setItem('redirectUrl', curPath);
        //     next({path: PATH['onboarding']});
        // }
        // if (!userInfo && userLoginArr.indexOf(curPath) === -1 && curPath !== PATH['onboarding']) {
        //     localStorage.setItem('redirectUrl', curPath);
        //     // "https://passport.baidu.com/v2/?login&u=https://mediago.baidu.com/business/login/success?r=/business/login/demo"
        //     window.location.href = 'https://passport.baidu.com/v2/?login&u='
        //         + location.protocol + '//' + location.host + '/' + env['MODULE_CMP'] + '/login/success?r='
        //         + curPath;
        //     next();
        // }
        if (curPath === PATH['setInfo']) {
            // let inviteCode = localStorage.getItem('inviteCode');
            if (userInfo) {
                // let redirectUrl = localStorage.getItem('redirectUrl');
                hasInfo ? next(PATH['onboarding-result']) : next();
                // hasInfo ? redirectUrl ? next(redirectUrl) : next(PATH['onboarding-result']) : next();
            } else {
                next(PATH['onboarding']);
            }
        } else if (curPath === PATH['onboarding']) {
            // if (userInfo && hasInfo) {
            //     next({path: PATH['onboarding-result']});
            // } else
            if (userInfo && !hasInfo) {
                next({path: PATH['setInfo']});
            } else {
                next();
            }
            // next();
        } else {
            if (userInfo && hasInfo) {
                // if (urlList && urlList.indexOf(to.path) > -1) {}
                if (curPath === PATH['report']) {
                    next(PATH['overview']);
                } else if (curPath === PATH['oldAccount']) {
                    next(PATH['account']);
                } else {
                    next();
                }
                return false;
            } else if (userInfo && !hasInfo) {
                localStorage.setItem('redirectUrl', curPath);
                next({path: PATH['setInfo']});
            } else {
                if (userLoginArr.indexOf(curPath) > -1) {
                    next(PATH['onboarding']);
                } else {
                    // console.log(from.path);
                    noNeedLogin.indexOf(curPath) > -1
                        ? next()
                        : window.location.href = location.protocol + '//' + location.host + '/'
                            + env['MODULE_CMP'] + '/login/?r='
                            + curPath;
                    // window.location.href = 'https://passport.baidu.com/v2/?login&u='
                    //     + location.protocol + '//' + location.host + '/' + env['MODULE_CMP'] + '/login/success?r='
                    //     + curPath;
                    // next();
                }
            }
        }
        next();
    } catch (e) {
        next({
            path: PATH['onboarding']
        });
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js